import Swiper from "swiper/bundle";

// init New Release Swiper
export const nRSwiper = new Swiper(".js-nr-slide", {
  loop: false,
  centeredSlides: false,
  slidesPerView: 'auto',
  speed: 500,
  navigation: {
    nextEl: ".p-top-release .swiper-button-next",
    prevEl: ".p-top-release .swiper-button-prev",
  },
  scrollbar: {
    el: ".p-top-release .swiper-scrollbar",
    hide: false,
    draggable: true,
  },
  breakpoints: {
    // ブレークポイント
    768: {
      // 画面幅600px以上で適用
      slidesPerView: 3,
    },
  },
});
